export default "__VITE_ASSET__CQuiIjD0__"